// src/components/WidgetCVTitle.jsx
import React from 'react';
import { Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Utils } from 'core/utils';

const formatText = (value, fallback = '') => {
    if (!Utils.normalizeText) return value ?? fallback;
    return Utils.normalizeText(value, fallback);
};

const WidgetCVTitle = ({ cv, editable = true, onEdit }) => {
  return (
    <Box className="relative p-4 mb-3 border border-gray-300 rounded-lg text-center bg-white" sx={{ position: 'relative' }}>
      {/* Edit Button */}
      {editable && onEdit && (
        <IconButton
          onClick={onEdit}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
          size="small"
          title="Edit Personal Information"
        >
          <EditIcon />
        </IconButton>
      )}

      {/* Profile Picture */}
      <div>
        <img
          src={cv && cv.image ? cv.image : '/assets/images/user.png'}
          alt="User"
          className="w-100p h-100p rounded-full bg-gray-300 object-cover"
        />
      </div>

      {/* Name */}
      <div className="mt-2 font-bold text-lg">
        {cv ? formatText(`${cv.name || ''} ${cv.last_name || ''}`.trim() || 'Name LastName') : 'Name LastName'}
      </div>

      {/* Title */}
      <div className="mt-2 font-bold text-base">
        {cv ? formatText(cv.title) : 'Title'}
      </div>

      {/* Contact Info */}
      <div className="mt-3 flex justify-center gap-x-5 items-center">
        {cv?.email && (
          <div className="flex items-center">
            <span className="ml-2 font-bold text-sm">
              {formatText(cv.email)}
            </span>
          </div>
        )}
        {cv?.phone && (
          <div className="flex items-center">
            <span className="ml-2 font-bold text-sm">
              {formatText(cv.phone)}
            </span>
          </div>
        )}
      </div>
    </Box>
  );
};

export default WidgetCVTitle;
